module.exports = __webpack_public_path__ + "img/BANNER-REVISTA-TRAEESA-MOVIL.ca274e86.jpg";